import React from 'react';
import PropTypes from 'prop-types';
import { ContainerWrapper } from './styled';

const Container = (props) => {
    const { children, className, zeroPadding } = props;
    const styleProps = { zeroPadding };

    return (<ContainerWrapper className={className} {...styleProps}>
        {children}
    </ContainerWrapper>);
};

Container.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    zeroPadding: PropTypes.bool
};

export default Container;



// WEBPACK FOOTER //
// ./app/components/container/index.js